import axios from "axios";
import { Contact } from "@/api/contacts";

export interface BlackBoard {
  id: string | null;
  title: string;
  countTasks: number;
  countDeletedTasks: number;
  blackBoardColumns: BlackBoardColumn[];
  activeForNewContact: boolean;
  projectOnly: boolean;
}

export interface BlackBoardColumn {
  id: string | null;
  orderKey: number;
  name: string;
}

interface BlackBoardApi {
  list(): Promise<BlackBoard[]>;
  listOnlyProjects(): Promise<BlackBoard[]>;
  listAll(): Promise<BlackBoard[]>;
  listBy(contact: Contact): Promise<BlackBoard[]>;
  add(blackBoard: BlackBoard): Promise<string>;
  edit(id: string, blackBoard: BlackBoard): Promise<void>;
  delete(id: string): Promise<void>;

}

export const blackBoardApi: BlackBoardApi = {
  async list() {
    return (await axios.get("/api/blackboards")).data;
  },

  async listOnlyProjects() {
    return (await axios.get(`/api/blackboards/projects`)).data;
  },

  async listAll() {
    return (await axios.get("/api/blackboards/_all")).data;
  },

  async listBy(contact) {
    return (await axios.get(`/api/blackboards?contactRef=${contact.id}`)).data;
  },

  async edit(id, taskBoard) {
    return await axios.put(`/api/blackboards/${id}`, taskBoard);
  },

  async add(taskBoard) {
    return (await axios.post("/api/blackboards", taskBoard)).data;
  },

  async delete(id) {
    return await axios.delete(`/api/blackboards/${id}`);
  },
};
